import { render } from "./CompanyEmailInviteCognitoLandingView.vue?vue&type=template&id=0ccbd43c&ts=true"
import script from "./CompanyEmailInviteCognitoLandingView.vue?vue&type=script&lang=ts"
export * from "./CompanyEmailInviteCognitoLandingView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__